import React from "react";
import "./SubtitleLines.css";

const SubtitleLines = props => {
  const RTL = { direction: props.ltr ? "ltr" : "rtl" };
  return <div className="titleTeam1" style={Object.assign(RTL, props.style)} />;
};

export default SubtitleLines;
